import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Layout, Tabs, Typography } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { HomeContainer, PageHeader, PageTitle, PageSubtitle } from '../Home/styles';
import { AccountSetupSection } from '../../components/AccountSetup';
import DesktopDownload from '../DesktopDownload';

const { Content } = Layout;

const TABS = ['accounts', 'desktop'] as const;
type SettingsTab = typeof TABS[number];

const SettingsPage: React.FC = () => {
    // The tab lives in the URL so "Get the desktop app" links can land on it directly.
    const [params, setParams] = useSearchParams();
    const requested = params.get('tab');
    const tab: SettingsTab = TABS.includes(requested as SettingsTab) ? (requested as SettingsTab) : 'accounts';

    return (
        <HomeContainer>
            <Content style={{ padding: '16px', maxWidth: 1100 }}>
                <PageHeader>
                    <div>
                        <PageTitle>
                            <SettingOutlined style={{ marginRight: '8px', color: '#0ECB81' }} />
                            Settings
                        </PageTitle>
                        <PageSubtitle>Your accounts' services and the desktop app.</PageSubtitle>
                    </div>
                </PageHeader>

                <Tabs
                    activeKey={tab}
                    onChange={(key) => setParams({ tab: key }, { replace: true })}
                    items={[
                        {
                            key: 'accounts',
                            label: 'Accounts',
                            children: (
                                <>
                                    <Typography.Paragraph type="secondary">
                                        Where each account's money is read from and how its orders go out.
                                    </Typography.Paragraph>
                                    <AccountSetupSection active={tab === 'accounts'} />
                                </>
                            ),
                        },
                        {
                            key: 'desktop',
                            label: 'Desktop app',
                            children: (
                                <div style={{ maxWidth: 880 }}>
                                    <DesktopDownload embedded />
                                </div>
                            ),
                        },
                    ]}
                />
            </Content>
        </HomeContainer>
    );
};

export default SettingsPage;
